import { action } from "mobx";
import AwsS3UploadSignedUrlRepository from "~/repository/AwsS3/AwsS3UploadSignedUrlRepository";

class AwsS3UploadSignedUrlStore {
  /**
   * @property {AwsS3UploadSignedUrlRepository|null}
   */
  awsS3UploadSignedUrlRepository = null;

  constructor() {
    this.awsS3UploadSignedUrlRepository = new AwsS3UploadSignedUrlRepository();
  }

  @action
  getOne(data) {
    return this.awsS3UploadSignedUrlRepository.fetchOne(data);
  }
}

export default AwsS3UploadSignedUrlStore;
